var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "p",
      { staticStyle: { padding: "10px" } },
      [
        _c(
          "el-popover",
          { attrs: { placement: "bottom", trigger: "hover" } },
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "card" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              _vm._l(_vm.reviewRecord, function (item, index) {
                return _c(
                  "el-tab-pane",
                  {
                    key: index,
                    attrs: { label: index + 1 + "版", name: "version" + index },
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "review-header" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c("span", [_vm._v("审版结果:")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "content-box" }, [
                                    _vm._v(_vm._s(item.reviewResults)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c("span", [_vm._v("处理意见:")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "content-box" }, [
                                    _vm._v(_vm._s(item.handlingOpinionsName)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c("span", [_vm._v("是否需要设计确认:")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "content-box" }, [
                                    _vm._v(
                                      _vm._s(item.isNeedDesigner ? "是" : "否")
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c("span", [_vm._v("样衣模特:")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "content-box" }, [
                                    _vm._v(_vm._s(item.modelName)),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "textarea-box" }, [
                        _c(
                          "div",
                          { staticClass: "align-start" },
                          [
                            _c("span", { staticClass: "txt" }, [
                              _vm._v("版型:"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "textarea-input",
                              attrs: {
                                type: "textarea",
                                rows: "4",
                                disabled: true,
                                placeholder: "请输入内容",
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: item.typeRequirements,
                                callback: function ($$v) {
                                  _vm.$set(item, "typeRequirements", $$v)
                                },
                                expression: "item.typeRequirements",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "align-start" },
                          [
                            _c("span", { staticClass: "txt" }, [
                              _vm._v("工艺:"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "textarea-input",
                              attrs: {
                                type: "textarea",
                                rows: "4",
                                disabled: true,
                                placeholder: "请输入内容",
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: item.technologicalRequirements,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item,
                                    "technologicalRequirements",
                                    $$v
                                  )
                                },
                                expression: "item.technologicalRequirements",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "align-start" },
                          [
                            _c("span", { staticClass: "txt" }, [
                              _vm._v("面料:"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "textarea-input",
                              attrs: {
                                type: "textarea",
                                rows: "4",
                                disabled: true,
                                placeholder: "请输入内容",
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: item.fabricRequirements,
                                callback: function ($$v) {
                                  _vm.$set(item, "fabricRequirements", $$v)
                                },
                                expression: "item.fabricRequirements",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "align-start" },
                          [
                            _c("span", { staticClass: "txt" }, [
                              _vm._v("大货工艺要求:"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "textarea-input",
                              attrs: {
                                type: "textarea",
                                rows: "4",
                                disabled: true,
                                placeholder: "请输入内容",
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: item.processRequirements,
                                callback: function ($$v) {
                                  _vm.$set(item, "processRequirements", $$v)
                                },
                                expression: "item.processRequirements",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#FF8850",
                  "text-decoration": "underline",
                  cursor: "pointer",
                },
                attrs: { slot: "reference" },
                slot: "reference",
              },
              [_vm._v("审版意见")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }